import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

const containerAbsoluteCss = ({ absolute }) =>
  absolute &&
  css`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%) translateY(-52px);

    @media screen and (min-width: ${themeGet('breakpoints.0')}) {
      transform: translateX(-50%) translateY(-20px);
    }

    @media screen and (min-width: ${themeGet('breakpoints.3')}) {
      transform: none;
      left: -120px;
      flex-direction: column;
    }
  `

const shouldForwardProp = prop => {
  return !['absolute'].includes(String(prop))
}

export const Container = styled(Flex).withConfig({
  shouldForwardProp,
})`
  flex-direction: row;

  > button {
    outline: none;
    margin-bottom: 16px;
    margin-right: 16px;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.75;
    }
  }

  ${containerAbsoluteCss}
`
